<div class="flex justify-between items-center mb-4">
  <h2 class="text-md font-semibold">Supersets</h2>
  @if (CanAddSuperset) {
    <p-button
      type="button"
      label="Add Superset"
      icon="pi pi-plus"
      (onClick)="AddSuperset()"
    ></p-button>
  }
</div>
<div [class.backdrop-blur-sm]="showDialog" class="transition-all duration-300">
  <p-card>
    <p-table
      #dt
      size="small"
      [value]="supersets"
      dataKey="name"
      [columns]="cols"
      stripedRows="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 50, 100, 200]"
      [paginator]="true"
      [scrollable]="true"
      [globalFilterFields]="['name', 'dashboardId']"
    >
      <ng-template #caption>
        <div class="flex">
          <p-button
            label="Clear"
            [outlined]="true"
            icon="pi pi-filter-slash"
            (click)="dt.clear(); searchInput.value = ''"
          />
          <p-iconfield iconPosition="left" class="ml-auto">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input
              #searchInput
              pInputText
              type="text"
              (input)="dt.filterGlobal(searchInput.value, 'contains')"
              placeholder="Search Supersets"
            />
          </p-iconfield>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            <div class="flex items-center">
              Name
              <p-columnFilter
                type="text"
                field="name"
                placeholder="Search by name"
                display="menu"
              ></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="dashboardId">
            <div class="flex items-center">
              Dashboard ID
              <p-columnFilter
                type="text"
                field="dashboardId"
                placeholder="Search by dashboard ID"
                display="menu"
              ></p-columnFilter>
            </div>
          </th>
          <th>
            <div class="flex items-center">
              Active
              <p-columnFilter
                type="boolean"
                field="isActive"
                display="menu"
              ></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="createdBy">
            <div class="flex items-center">
              Created By
              <p-columnFilter
                type="text"
                field="createdBy"
                placeholder="Search by Created By"
                display="menu"
              ></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="modifiedBy">
            <div class="flex items-center">
              Modified By
              <p-columnFilter
                type="text"
                field="modifiedBy"
                placeholder="Search by Modified By"
                display="menu"
              ></p-columnFilter>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-superset>
        <tr>
          <td>
            <a
              *ngIf="CanEditSuperset"
              href="javascript:void(0)"
              class="p-button-primary"
              (click)="showDetails(superset)"
              style="
                text-decoration: underline;
                color: #2c69c7;
                cursor: pointer;
              "
            >
              {{ superset.name }}
            </a>
            <span *ngIf="!CanEditSuperset" style="color: #2c69c7">{{
              superset.name
            }}</span>
          </td>
          <td>{{ superset.dashboardId }}</td>
          <td>
            <p-toggleswitch
              [(ngModel)]="superset.isActive"
              [disabled]="!CanEditSuperset"
              (ngModelChange)="
                CanEditSuperset && onToggleChange(true, $event, superset)
              "
            />
          </td>
          <td>{{ superset.createdBy || '-' }}</td>
          <td>{{ superset.modifiedBy || '-' }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center">No supersets found.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<p-dialog
  [header]="isEdit ? 'Update Superset' : 'Add Superset'"
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
>
  <div [formGroup]="supersetForm" class="space-y-4">
    <div class="grid grid-cols-2 gap-4 pt-1">
      <p-floatlabel variant="on">
        <input pInputText formControlName="name" id="name" class="w-full" />
        <label for="name" class="required-label">Name</label>
      </p-floatlabel>
      <p-floatlabel variant="on">
        <input
          pInputText
          formControlName="dashboardId"
          id="dashboardId"
          class="w-full"
          type="text"
        />
        <label for="dashboardId">Dashboard ID</label>
      </p-floatlabel>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <div class="flex items-center space-x-2">
        <p-checkbox
          formControlName="isActive"
          inputId="isActive"
          binary="true"
        ></p-checkbox>
        <label for="isActive" class="text-sm">Is Active</label>
      </div>
      <div></div>
    </div>
    <!-- Removed Created By and Modified By fields from form -->
    <div class="flex justify-end gap-4 mt-4">
      <p-button
        type="button"
        severity="secondary"
        label="Cancel"
        (click)="showDialog = false; supersetForm.reset(); submitted = false"
      ></p-button>
      <p-button
        type="submit"
        (click)="submit()"
        [label]="isEdit ? 'Update' : 'Add'"
      ></p-button>
    </div>
  </div>
</p-dialog>
<div class="card flex justify-center gap-2">
  <p-toast />
  <p-confirmdialog />
  <!-- <p-button (click)="confirm1($event)" label="Save" [outlined]="true" />
  <p-button
    (click)="confirm2($event)"
    label="Delete"
    severity="danger"
    [outlined]="true"
  />
</div> -->
</div>
